import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import { inputStyle } from '../../utils/formStyle';
import { FormInputLabel } from './FormInputLabel';

export const FormTextArea = React.forwardRef((props, ref) => {
  const { label, error, maxLength, showCount = true, onChange, rows = 4, ...rest } = props;
  const [charCount, setCharCount] = useState(rest.value?.length || 0);

  useEffect(() => {
    setCharCount(rest.value?.length || 0);
  }, [rest.value]);

  const handleChange = (e) => {
    setCharCount(e.target.value.length);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className='flex flex-col gap-1 flex-grow'>
      {label && (
        <div className='flex justify-between items-center'>
          <FormInputLabel label={label} isRequired={rest.required} />
          {showCount && maxLength && (
            <span className='text-sm text-gray-500'>
              {charCount} / {maxLength}
            </span>
          )}
        </div>
      )}
      <TextField
        className='[&_.MuiInputBase-root]:!rounded-lg'
        sx={inputStyle}
        multiline
        rows={rows}
        inputProps={{ maxLength }}
        {...rest}
        onChange={handleChange}
        inputRef={ref}
        error={!!error}
      />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormTextArea.displayName = 'FormTextArea';
